export default __webpack_public_path__ + "static/media/vaporDreams.475b6190.png";